import { render, staticRenderFns } from "./knowledgeBase.vue?vue&type=template&id=f0683ac0&"
import script from "./knowledgeBase.vue?vue&type=script&lang=ts&"
export * from "./knowledgeBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports